// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__2rClv","footerDark":"footer_footerDark__3b4JH","icons":"footer_icons__2mK8D","icon":"footer_icon__sfLl4"};